import { inject } from '@angular/core';
import { ResolveFn, Router } from '@angular/router';
import { VeterinarianService } from '@pxl/models/contracts';
import { AccountRoutingRouteNames, AppRoutingRouteNames } from '@pxl/route-names';
import { VeterinarianModel } from '@pxl/shared/generated';

export const externalVetResolver: ResolveFn<VeterinarianModel | undefined> = async (route) => {
    const router = inject(Router);
    const externalVetId = route.params[AccountRoutingRouteNames.externalVeterinarianIdParam];
    const vetBranch =
        route.params[AccountRoutingRouteNames.veterinarianBranchParam] ??
        route.queryParams[AccountRoutingRouteNames.veterinarianBranchParam];
    let vet: VeterinarianModel | undefined;
    vet = await inject(VeterinarianService)
        .getVeterinarianAsAnonymous(externalVetId, vetBranch)
        .catch(() => undefined as never);
    if (!vet) {
        await router.navigate([AppRoutingRouteNames.Error]);
        return undefined;
    }
    return vet;
};
